import { Button, EmptyState, LoadingState } from '@repo/ui'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ArrowLeft, BookOpen } from 'lucide-react'

import { KnowledgeEditorPage } from '@/components/knowledge/KnowledgeEditorPage'
import { useAuth } from '@/hooks/use-auth'
import { useKnowledgeBaseDetail } from '@/hooks/use-knowledge'

export const Route = createFileRoute('/_app/conhecimento/$knowledgeBaseId')({
  component: EditKnowledgePage,
})

function EditKnowledgePage() {
  const navigate = useNavigate()
  const { knowledgeBaseId } = Route.useParams()
  const { currentOrgId } = useAuth()
  const {
    data: kb,
    isLoading,
    isError,
  } = useKnowledgeBaseDetail(currentOrgId, knowledgeBaseId)

  function backToList() {
    void navigate({ to: '/conhecimento' })
  }

  if (!currentOrgId) {
    return (
      <div className="text-muted-foreground flex flex-1 items-center justify-center">
        Selecione uma organização
      </div>
    )
  }

  if (isLoading) {
    return <LoadingState className="flex-1" />
  }

  if (isError || !kb) {
    return (
      <EmptyState
        variant="inline"
        className="min-h-80"
        icon={BookOpen}
        title="Base não encontrada"
        description="Ela pode ter sido removida ou pertencer a outra organização."
        action={
          <Button type="button" variant="outline" onClick={backToList}>
            <ArrowLeft className="h-4 w-4" />
            Voltar para Conhecimento
          </Button>
        }
      />
    )
  }

  return (
    <KnowledgeEditorPage
      orgId={currentOrgId}
      kb={kb}
      loading={isLoading}
      onCancel={backToList}
      onSuccess={backToList}
    />
  )
}
